import React from "react";
import styled from "styled-components";

import { A, H1 } from "commons";
import { ContentHolder } from "commons/src/styled/ContentHolder";

import { TermsAndConditionsLink, PrivacyPolicyLink } from "../Login/PlatformLinks";

export function Legal() {
    return (
        <ContentHolder>
            <H1>Legal info</H1>
            <Centered>
                <p>
                    Access to our{" "}
                    <A href={TermsAndConditionsLink} target="_blank">
                        Terms and Conditions
                    </A>
                </p>
                <p>
                    Access to our{" "}
                    <A href={PrivacyPolicyLink} target="_blank">
                        Privacy Policy
                    </A>
                </p>
            </Centered>
        </ContentHolder>
    );
}

const Centered = styled.div`
    text-align: center;
`;
